import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    borderRadius: theme.radius.lg,
    backgroundColor: theme.white,
    overflow: 'hidden',
    padding: 0,
    gap: theme.other.spacing._16,
    display: 'flex',
    flexDirection: 'column',

    '&.isOpen': {
      alignSelf: 'stretch',
    },

    '& .mantine-Accordion-control': {
      padding: theme.other.spacing._16,

      '@media (hover: hover)': {
        transition: 'opacity 0.2s ease-in-out',

        '&:not(:disabled):hover': {
          opacity: 0.5,
          backgroundColor: theme.white,
        },
      },
    },

    '& .mantine-Accordion-chevron': {
      marginRight: theme.other.spacing._4,
    },

    '& .mantine-Accordion-item': {
      borderBottom: 'none',
    },

    '& .mantine-Accordion-content': {
      padding: theme.other.spacing._16,
      paddingTop: 0,
    },
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-start',
  },

  title: {
    color: theme.colors.gray[9],
    fontWeight: 600,
  },

  countBadge: {
    backgroundColor: theme.colors.red[3],
    borderTopRightRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 10,
    borderBottomRightRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 10,
    borderTopLeftRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 10,
    borderBottomLeftRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 10,
    minWidth: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.other.spacing._8,
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '0 6px',

    '&.isCapped': {
      padding: /* eslint-disable-line local-rules/use-theme-tokens */ '0 4px 0 6px',
    },
  },

  footer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.other.spacing._16,
  },

  viewAllButtonHeader: {
    color: theme.colors.gray[5],
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
  },
  viewAllButtonFooter: {
    color: theme.colors.gray[7],
  },

  widgetCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
  },

  widgetCardContainerFullWidth: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: theme.other.spacing._8,

    '& > *': {
      flexGrow: 1,
      maxWidth: '50%',
    },
  },
}));

export default useStyles;
